import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_ACCKEY_LIST', data);
};

const setProjectList = ({ commit }, data) => {
  commit('SET_PROJECT_LIST_ACCKEY_LIST', data);
};

export default {
  async SEARCH_GRID_ACCKEY_LIST(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/list/etc-info-list?${StringUtil.queryStringfy(param)}`);
    console.log(data.data);
    setGridData(store, data.data);
  },
  async SEARCH_PROJECT_LIST_ACCKEY_LIST(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/list/project?${StringUtil.queryStringfy(param)}`);

    setProjectList(store, data.data);
  },
  async EXCEL_UPLOAD_ACCKEY_LIST(store, param) {
    const data = await RequestUtil.post(`${SDLUtil.API_URL}/accesskey/list/excel-upload`, param);
    return data;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/list/accKeyListAction.js